import axios from 'axios';
import React, { use, useState,useEffect } from 'react';

const ModalCreate = ({ closeModal,title,subTitle,addFunct,inputName,mainSetter}) => {
    const [storeTitle, setStoreTitle] = useState({});


    const handleInputChange = (name,e) => {
        setStoreTitle({
            ...storeTitle,
            [name]: e.target.value
        });
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try{
            const response = await addFunct(storeTitle);
           
            console.log("handleInsideModal",response);
            const newId = response.data.data.id;

           
            mainSetter((prevState) => [...prevState, {
                title: storeTitle.title,
                id: newId
            }]); 
            console.log("Response data:", response.data);
            console.log("New ID:", response.data.id);
 
            closeModal();
         }catch(error){
            console.log(error);
        }
        
        console.log("Form Submitted");
    }
    
    useEffect(() => {
        console.log("StoreTitle:",storeTitle);
    }, [storeTitle ]);
    
    return (
        <div
            className="fixed z-10 inset-0 overflow-y-auto"
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
        >
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <div
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                    aria-hidden="true"
                ></div>
                <span
                    className="hidden sm:inline-block sm:align-middle sm:h-screen"
                    aria-hidden="true"
                >
                    &#8203;
                </span>
                <div
           
                    className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-headline"
                >
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div className="sm:flex sm:items-start mb-3">
                                 <h3
                                    className="text-lg leading-6 font-medium text-gray-900"
                                    id="modal-headline"
                                >
                                    {title}
                                </h3>
                                
                            
                            
                        </div>
                       
                            
                        <label className="text-sm text-gray-500">{subTitle}</label>
                            <input
                            name={inputName}
                            onChange={(e) => handleInputChange(inputName,e)}
                                type="text"
                                className=" px-4 py-2 mt-4 border-[2px] border-black w-full"
                                placeholder="Enter title"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleFormSubmit(e);
                                    }
                                }}
                                autofocus
                            />
                            
                     
                       
                    </div>
                    
                    <div className="bg-gray-50 px-4 py-3   sm:flex sm:flex-row-reverse">
                        <button
                            type="button"
                            onClick={handleFormSubmit}
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-500 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 "
                        >
                            Create 
                        </button>
                        <button
                            type="button"
                            onClick={closeModal}
                            className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-full"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );



    }
export default ModalCreate;